type Filters = {
    id: number
    category: string
}

export const filtersArray: Filters[] = [
    {
        id: 1,
        category: 'Food',
    },
    {
        id: 2,
        category: 'Training',
    },
    {
        id: 3,
        category: 'Partner training',
    },
]
